module.exports = __webpack_public_path__ + "static/img/qyfljc-ywlcxs.cffdf95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qyfljc-ywlcxs.png
// module id = GmXl
// module chunks = 0